export const initialState: WeatherDashboardState = {
  currentInterface: undefined,

  isLoadingInterfaceDetails: false,
}

export interface WeatherDashboardState {
  currentInterface?: SRCInterface

  isLoadingInterfaceDetails: boolean
}

export interface SRCInterface {
  id: number
  name: string
  organizationId: number[]
  pictureFileName: string
  pictureUrl: string
  softWareVersion: number
  state: string
  countryId: number
  countryName: string
  customName: string
  timeZoneId: number
  timeZone: string
  timeZoneName: string
  timeZoneOriginId: string
  updatedAt: string
  weatherLinkStations: WeatherLinkStation[]
  type: number
}

export interface WeatherLinkStation {
  location: string
  name: string
  sourceName: string
  weatherLinkStationId: number
}
